(() => {
  const hideBroken = (img) => {
    if (img.closest('.logo') || img.classList.contains('logo-img') || img.classList.contains('footer-logo-img') || img.classList.contains('hero__photo')) return;
    img.style.display = 'none';
    img.setAttribute('data-broken', 'true');
  };
  document.querySelectorAll('img').forEach((img) => {
    img.addEventListener('error', () => hideBroken(img));
    if (img.complete && img.naturalWidth === 0 && img.src) hideBroken(img);
  });
  const navBtn = document.querySelector('[data-open-nav]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (navBtn && nav) {
    navBtn.addEventListener('click', () => {
      const hidden = nav.hasAttribute('hidden');
      if (hidden) nav.removeAttribute('hidden');
      else nav.setAttribute('hidden', '');
    });
  }
  const header = document.querySelector('[data-site-header]');
  const mega = document.querySelector('[data-mega-menu]');
  const trigger = document.querySelector('[data-mega-trigger]');
  if (header && mega && trigger) {
    mega.removeAttribute('hidden');
    let closeTimer;
    const openMega = () => {
      clearTimeout(closeTimer);
      header.classList.add('is-mega-open');
    };
    const closeMega = () => {
      closeTimer = setTimeout(() => header.classList.remove('is-mega-open'), 120);
    };
    trigger.addEventListener('mouseenter', openMega);
    trigger.addEventListener('focusin', openMega);
    mega.addEventListener('mouseenter', openMega);
    trigger.addEventListener('mouseleave', closeMega);
    mega.addEventListener('mouseleave', closeMega);
    header.addEventListener('mouseleave', closeMega);
  }
  const mobileMegaBtn = document.querySelector('[data-mega-mobile]');
  const mobileMega = document.querySelector('[data-mega-mobile-panel]');
  if (mobileMegaBtn && mobileMega) {
    mobileMegaBtn.addEventListener('click', () => {
      const hidden = mobileMega.hasAttribute('hidden');
      if (hidden) mobileMega.removeAttribute('hidden');
      else mobileMega.setAttribute('hidden', '');
    });
  }
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    // "+6" unfolds the remaining dots in place instead of leaving the grid.
    const more = card.querySelector('[data-swatch-more]');
    const strip = card.querySelector('[data-swatches]');
    if (more && strip) {
      more.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        strip.classList.add('is-open');
        more.setAttribute('aria-expanded', 'true');
        more.remove();
      });
    }
    card.querySelectorAll('[data-swatch]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        card.querySelectorAll('[data-swatch]').forEach((s) => s.classList.remove('is-active'));
        btn.classList.add('is-active');
        const img = card.querySelector('[data-card-image]');
        if (img && btn.dataset.image) {
          // The card photo carries a srcset, and a srcset outranks src - setting src
          // alone leaves the first colour on screen. Drop it before swapping.
          img.removeAttribute('srcset');
          img.src = btn.dataset.image;
        }
        const sale = card.querySelector('.price__sale');
        const compare = card.querySelector('.price__compare');
        const off = card.querySelector('.off-badge');
        if (sale && btn.dataset.price) sale.textContent = btn.dataset.price;
        if (compare) {
          if (btn.dataset.compare) {
            compare.textContent = btn.dataset.compare;
            compare.hidden = false;
          } else {
            compare.textContent = '';
            compare.hidden = true;
          }
        }
        if (off) {
          if (btn.dataset.save) {
            off.textContent = '-' + btn.dataset.save;
            off.hidden = false;
          } else {
            off.textContent = '';
            off.hidden = true;
          }
        }
      });
    });
  });
})();

/* Park the sticky header group so the announcement bar scrolls out of view and
   the logo header stays pinned. The offset is pure CSS (a negative sticky top);
   this only measures the bar so the offset stays exact when the sale text wraps.
   Deliberately no scroll listener: the previous one toggled state on a
   threshold, which made scrolling back to the top a fight. */
(() => {
  const bar = document.querySelector('.announcement');
  if (!bar) return;

  const measure = () => {
    document.documentElement.style.setProperty('--announcement-h', bar.offsetHeight + 'px');
  };

  measure();
  window.addEventListener('resize', measure, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);
})();

/* Brand spelling: Svelna → Švelna in leftover Shopify strings (menus, product
   titles, apps). Skip scripts, inputs, and mailto so emails stay svelna.lt. */
(() => {
  const fix = (s) => (s && s.indexOf('Svelna') !== -1 ? s.replaceAll('Svelna', 'Švelna') : s);
  const walk = (root) => {
    if (!root) return;
    const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(n) {
        const p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        const t = p.tagName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'NOSCRIPT' || t === 'TEXTAREA' || t === 'INPUT') {
          return NodeFilter.FILTER_REJECT;
        }
        if (t === 'A' && (p.getAttribute('href') || '').indexOf('mailto:') === 0) {
          return NodeFilter.FILTER_REJECT;
        }
        if (!n.nodeValue || n.nodeValue.indexOf('Svelna') === -1) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    while (it.nextNode()) nodes.push(it.currentNode);
    nodes.forEach((n) => { n.nodeValue = fix(n.nodeValue); });
    root.querySelectorAll('[alt],[aria-label],[title]').forEach((el) => {
      ['alt', 'aria-label', 'title'].forEach((a) => {
        if (el.hasAttribute(a)) el.setAttribute(a, fix(el.getAttribute(a)));
      });
    });
  };
  walk(document.body);
  if (document.title.indexOf('Svelna') !== -1) document.title = fix(document.title);
})();

/* Judge.me: when the open review tab is empty (e.g. "Produktų atsiliepimai (0)")
   and another tab has reviews (the imported store reviews), open that one, so a
   shopper never lands on "Būkite pirmas". Runs once per page, when the widget
   appears; after that the shopper's own tab clicks are left alone. Covers the
   desktop buttons and the mobile dropdown. */
(function () {
  var done = false;
  function count(el) {
    var n = parseInt(((el.textContent || '').split('(')[1] || ''), 10);
    return isNaN(n) ? -1 : n;
  }
  function trySwitch() {
    if (done) return true;
    var tabs = document.querySelectorAll('button.jdgm-tab');
    if (tabs.length < 2) return false;
    var active = document.querySelector('button.jdgm-tab.jdgm-tab--active') || tabs[0];
    done = true;
    if (count(active) !== 0) return true;
    var target = null;
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i] !== active && count(tabs[i]) > 0) { target = tabs[i]; break; }
    }
    if (!target) return true;
    target.click();
    var sel = document.querySelector('select.jdgm-tab-dropdown__select');
    if (sel) {
      var want = (target.textContent || '').trim();
      for (var j = 0; j < sel.options.length; j++) {
        if ((sel.options[j].textContent || '').trim() === want) {
          sel.selectedIndex = j;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
    return true;
  }
  if (trySwitch()) return;
  var obs = new MutationObserver(function () { if (trySwitch()) obs.disconnect(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { obs.disconnect(); }, 60000);

  /* Videos marked data-lazy-video carry no autoplay and preload="none": they start only near the viewport,
     so they never compete with the hero image for bandwidth on page load. */
  /* Posters as well: a poster attribute downloads on page load even with preload="none", so lazy videos carry
     data-poster and get the real poster once their section is within 800 px of the screen. The section is
     observed, not the video: on phones the video trio is a sideways strip whose off-screen slides never intersect. */
  const posterVideos = document.querySelectorAll('video[data-poster]');
  if (posterVideos.length) {
    const setPoster = (v) => { if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); };
    if ('IntersectionObserver' in window) {
      const groups = new Map();
      posterVideos.forEach((v) => {
        const box = v.closest('[id^="shopify-section"]') || v;
        if (!groups.has(box)) groups.set(box, []);
        groups.get(box).push(v);
      });
      const pio = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { (groups.get(e.target) || []).forEach(setPoster); pio.unobserve(e.target); } });
      }, { rootMargin: '800px 0px' });
      groups.forEach((_, box) => pio.observe(box));
    } else {
      posterVideos.forEach(setPoster);
    }
  }
  const lazyVideos = document.querySelectorAll('video[data-lazy-video]');
  if (lazyVideos.length) {
    const start = (v) => { const p = v.play(); if (p && p.catch) p.catch(() => {}); };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) start(e.target); else e.target.pause(); });
      }, { rootMargin: '200px 0px' });
      lazyVideos.forEach((v) => io.observe(v));
    } else {
      lazyVideos.forEach(start);
    }
  }
})();
